@if (referredOutEmail() && isInternalReferral()) {
    <sh-user-identifier [name]="internalUserName()" [showLabel]="false" [id]="uid"></sh-user-identifier>
    <sh-tooltip [label]="referredOutEmail()" [target]="uid" placement="top" variation="short"></sh-tooltip>
} @else if (referredOutTeam()) {
    <div class="team-entry">
        <sh-user-identifier
            class="team-avatar"
            [initials]="teamInitials()"
            [showLabel]="false"
            [id]="uid"
        ></sh-user-identifier>
        <span class="team-name">{{ teamName() }}</span>
    </div>
    <sh-tooltip [label]="teamName()" [target]="uid" placement="top" variation="short"></sh-tooltip>
} @else if (referredOutEmail()) {
    <div class="w-8 h-8 rounded-full bg-shui-base-4 flex items-center justify-center" [id]="uid">
        <sh-icon icon="sign-out" size="s" class="scale-[0.9] !w-[20px] !h-[20px]"></sh-icon>
    </div>
    <sh-tooltip [label]="referredOutEmail()" [target]="uid" placement="top" variation="short"></sh-tooltip>
}
